<template>
    <div class="questionTransferMain">
        <p class="title">将试题转移至</p>
        <el-radio-group v-model="questionTransfer">
            <el-radio :label="index" v-for="(item,index) in assemblyData.segment_list" :key="index">{{item.name}}</el-radio>
        </el-radio-group>
        <el-button size="small" type="primary" @click="questionTransferSubmit">确定</el-button>
    </div>
</template>

<script>
import $store from '../store'
export default {
    data () {
        return {
            questionTransfer:[]//转移列表
        }
    },
    methods: {
        questionTransferSubmit(){//转移提交
            $store.commit('SETTESTTRANSFER',this.questionTransfer)
            this.$nextTick(()=>{
                $store.commit('SETQUESTIONTRANSFERSHOW')
            })
        }
    },
    computed: {
        assemblyData(){
            return $store.state.assemblyData
        },
        currentNode(){
            return $store.state.currentNode
        }
    },
    mounted () {
        this.questionTransfer = this.currentNode[0]
    }
}
</script>




// WEBPACK FOOTER //
// packages/question-assembly/src/questionTransferOut.vue